<template>
	<tr>
		<td class="drag-handle" style="cursor: grab">
			<i class="fas fa-grip-lines"></i>
		</td>
		<td>
			<div>#{{ position }}</div>
		</td>
		<td>
			<div class="d-flex gap-3 align-items-center">
				<div
					:style="{
						width: '60px',
						height: '60px',
						backgroundColor: topic.color,
						borderRadius: '10px',
					}"
				>
					<img :src="topic.image" alt="" style="height: 100%; width: 100%" />
				</div>
				<div>{{ topic.name }}</div>
			</div>
		</td>
		<td class="text-center">
			<div v-if="topic.enabled">
				<span class="badge badge-success">Activado</span>
			</div>
			<div v-else><span class="badge badge-danger">Desactivado</span></div>
		</td>
		<td class="text-center">
			<router-link class="btn btn-outline-dark m-1" :to="'/app/blog/topic/' + topic.UUID">
				<i class="fas fa-edit"></i>
			</router-link>
			<button class="btn btn-outline-danger m-1" @click="deleteTopic()">
				<i class="fas fa-trash"></i>
			</button>
		</td>
	</tr>
</template>

<script>
import TopicService from "@/services/topic.service";

import Swal from "sweetalert2";

export default {
	name: "TopicRow",
	props: {
		topic: Object,
		position: Number,
	},
	data() {
		return {
			id: this.topic.UUID,
			updateTopic: {
				name: this.topic.name,
				description: this.topic.description,
				color: this.topic.color,
				enabled: this.topic.enabled,
			},
			image: "",
		};
	},
	methods: {
		uploadImage(event) {
			this.image = event.target.files[0];
		},
		async update(evt) {
			evt.preventDefault();
			window.$("#submitBtn").empty();
			window
				.$("#submitBtn")
				.append(
					'<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>Guardando'
				);

			const fd = new FormData();
			if (this.image != "") {
				fd.append("image", this.image);
			}
			fd.append("name", this.updateTopic.name);
			fd.append("color", this.updateTopic.color);
			fd.append("description", this.updateTopic.description);
			fd.append("enabled", this.updateTopic.enabled);
			evt.preventDefault();

			let response = await TopicService.updateTopic(this.topic.UUID, fd);

			window.$("#submitBtn").empty();
			window.$("#submitBtn").append("Guardar");
			if (response.status == 200) {
				Swal.fire({
					position: "top-end",
					icon: "success",
					title: "Se ha guardado correctamente.",
					showConfirmButton: false,
					timer: 1500,
					backdrop: false,
					toast: true,
				});
				this.$router.go();
			}
		},
		async deleteTopic() {
			const result = await Swal.fire({
				title: "¿Quieres confirmar esta acción?",
				text: `Vas a eliminar la temática: ${this.topic.name}`,
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#d33",
				cancelButtonColor: "#3085d6",
				confirmButtonText: "Sí, borrar",
				cancelButtonText: "Cancelar",
			});

			if (result.isConfirmed) {
				const response = await TopicService.deleteTopic(this.topic.UUID);
				if (response.status === 200 || response.status === 204) {
					Swal.fire({
						position: "top-end",
						icon: "success",
						title: "Se ha borrado correctamente.",
						showConfirmButton: false,
						timer: 2500,
						backdrop: false,
						toast: true,
					});

					// ⏳ Wait until the toast disappears before refreshing
					setTimeout(() => {
						this.$router.go();
					}, 2500); // 1500ms for toast + 100ms buffer
				} else {
					Swal.fire({
						icon: "error",
						title: "Error",
						text: "No se pudo borrar la temática.",
					});
				}
			}
		},
	},
};
</script>
